import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5em;
  }

  .no-padding {
    padding: 0 !important;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .footer {
    position: fixed;
    bottom: 3em;
    left: 1em;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2.4rem;

    @media (max-height: 768px) {
      bottom: 1rem;
    }
  }
`;
